import React from 'react';

const ReportPaymentManage = () => {
  return (
    <div>ReportPaymentManage</div>
  )
}

export default ReportPaymentManage;